import React, { useState } from 'react';
import { callHistory, fileExport } from '../../../api-services';
import { createTable } from '@tanstack/react-table';
import TableManager from '../../../components/TableManager';
import { useDispatch } from 'react-redux';
import { openUserDetailsModal } from '../../../redux/features/modalSlice';
import { useMutation } from 'react-query';
import swal from 'sweetalert';

const callTypeOptions = [
  { label: 'Inbound', value: 'Inbound' },
  { label: 'Outbound', value: 'Outbound' },
  { label: 'Missed', value: 'Missed' },
];
const numberFilterTypes = [
  { label: 'Less Than', value: 'less_than' },
  { label: 'Greater Than', value: 'greater_than' },
  { label: 'Is Equal To', value: 'is_equal' },
  { label: 'Is Not Equal To', value: 'is_not_equal' },
  { label: 'Less or Equal to', value: 'less_or_equal' },
  { label: 'Greater or Equal to', value: 'greater_or_equal' },
];
const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];

const initialValues = {
  filter: [
    {
      account_number: '',
      a_filter_type: '',
      placeholder: 'Enter MSISDN...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      // filterOptions: numberFilterTypes,
      label: 'MSISDN',
    },
    {
      caller_id_number: '',
      a_filter_type: '',
      placeholder: 'Enter Source...',
      type: 'text',
      shouldFilterOptionDisabled: false,
      label: 'Source',
    },
    {
      caller_destination: '',
      a_filter_type: '',
      placeholder: 'Enter Destination...',
      type: 'text',
      shouldFilterOptionDisabled: false,
      label: 'Destination',
    },
    {
      direction: '',
      a_filter_type: '',
      placeholder: 'Select Direction...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: callTypeOptions,
      label: 'Direction',
    },
    {
      cost: '',
      a_filter_type: '',
      placeholder: 'Enter Cost...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'Cost',
    },
    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Custom Date Range...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Date',
    },
  ],
};

const table = createTable();

const CallHistory = () => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);

  const { isLoading: isLoadingExporting, mutateAsync: mutateAsyncExport } =
    useMutation('fileExport', (payload) => fileExport(payload, 'call'), {
      onSuccess: (data) => {
        window.open(data?.data?.data);
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    });

  const handleOpenUserDetails = (shouldOpen, data) => {
    if (!shouldOpen) {
      return false;
    }

    dispatch(
      openUserDetailsModal({
        userModalOpen: true,
        userModalData: data,
      }),
    );
  };

  const handleFileExport = async (payload) => {
    await mutateAsyncExport(payload);
  };

  const columns = [
    table.createDataColumn('startdate', {
      id: 'startdate',
      header: 'Date',
      isSortable: true,
    }),
    table.createDataColumn((row) => row?.customer?.msisdn, {
      id: 'msisdn',
      header: 'MSISDN',
      shouldPointer: true,
      cell: (props) => (
        <span
          className="hover-name"
          onClick={() =>
            handleOpenUserDetails(
              props.getValue(),
              props?.row?.original?.customer,
            )
          }
        >
          {props.getValue()}
        </span>
      ),
    }),
    table.createDataColumn('caller_id_number', {
      id: 'caller_id_number',
      header: 'Source',
    }),
    table.createDataColumn('destination_number', {
      id: 'destination_number',
      header: 'Destination',
    }),
    table.createDataColumn('direction', {
      id: 'direction',
      header: 'Type',
      textAlign: 'left',
    }),
    table.createDataColumn('duration', {
      id: 'duration',
      header: 'Duration',
      isSortable: true,
    }),
    table.createDataColumn('cost', {
      id: 'cost ',
      header: 'Rate',
      isSortable: true,
    }),
    table.createDataColumn('charge', {
      id: 'charge',
      header: 'Charge',
      isSortable: true,
    }),
    table.createDataColumn('charge_mode', {
      id: 'charge_mode',
      header: 'Charge Mode',
      isSortable: true,
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="callHistory"
        fetcherFn={callHistory}
        title="Call Report"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
        shouldExport={true}
        exportCtaFn={handleFileExport}
        isExporting={isLoadingExporting}
      />
    </>
  );
};

export default CallHistory;
